import { IntlProvider, IntlProviderVue3 } from './IntlProvider';
import { IntlService } from './IntlService';
export { IntlProvider, IntlProviderVue3, IntlService };
// Automatic installation if Vue has been added to the global scope.
var vue = 'Vue';
if (typeof window !== 'undefined' && window[vue] && window[vue].component) {
    window[vue].component('kendo-intl-provider', IntlProvider);
}
